export const SEND_CONVERSATION_STEP_TO_SUBSCRIBER_REQUEST =
  "SEND_CONVERSATION_STEP_TO_SUBSCRIBER_REQUEST";
export const SEND_CONVERSATION_STEP_TO_SUBSCRIBER_SUCCESS =
  "SEND_CONVERSATION_STEP_TO_SUBSCRIBER_SUCCESS";
export const SEND_CONVERSATION_STEP_TO_SUBSCRIBER_FAILURE =
  "SEND_CONVERSATION_STEP_TO_SUBSCRIBER_FAILURE";
